// implements src\views\mixins\error-hadle.js
import { ref, watch, type Ref, type ComputedRef } from 'vue';
import { isArray, get } from 'lodash-es';
import type { ErrorList } from '@/types/core';

export type ErrorValue = string | ErrorList[]

interface UseErrorParams<T = Record<string, any>> {
  error?: ComputedRef<ErrorValue>;
  errors?: Ref<T>;
}

export function useError<T = Record<string, any>>(params?: UseErrorParams<T>) {
  const error = params?.error || ref('');
  const currentError = ref<string | null | undefined>(null)

  const errorWatchHandle = watch(error, async (newValue, oldValue) => {
    if (newValue !== oldValue) {
      currentError.value = isArray(newValue) ? newValue?.[0]?.message : newValue;
    }
  }, { immediate: true, deep: true });

  const errors: Ref<T> = params?.errors! || ref<T>({} as T);
  const getError = (field: string | (string | number)[], index: number = 0)  => {
    const fieldPath = Array.isArray(field) ? field : field.split('.');
    return get(errors.value, [...fieldPath, index, 'message'], '');
  }

  return { currentError, errorWatchHandle, getError, errors };
}
